<template>
  <button
    :class="'help-button ' + cssClass"
    title="Help"
    @click="$router.push('/help')"
  >
    ?
  </button>
</template>

<script>
export default {
  name: 'HelpButton',
  props: {
    cssClass: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.help-button {
  display: inline-block;
  height: 30px;
  width: 30px;
  margin: 3px;
  border-radius: 50%;
  background: white;
  color: black;
  text-decoration: none;
  text-align: center;
  vertical-align: middle;
  &.reverse {
    background: black;
    color: white;
  }
}
</style>